module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore41-2abac28135323902d3b15a809ff3e751.jpg";